/**
 *  All api related to system setting
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchSkus(options = {}) {
  const { page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchSkus',
    () => source.cancel('fetchSkus: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'skus',
      method: 'get',
      params,
      cancelToken: source.token,
      arrayFormat: 'brackets'

    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      skus: data.skus,
      pagination: data.skusPagination,
      next: _.get(data, 'skusPagination.nextPage') > page
        ? () =>
          fetchSkus({
            page: page + 1,
            ...others
          })
        : null,
      all: page === 1 && _.get(data, 'skusPagination.nextPage') > 1
        ? () => Promise.all(
          _.times(
            _.get(data, 'skusPagination.totalPages') - 1,
            (index) => fetchSkus({
              pageCountless: true,
              page: index + 2,
              ...others
            }),
          ),
        )
        : null,
      count: _.get(data, 'skusPagination.totalCount')
    }))
}
